import useSingleSessionInfoQuery from "@app/common/hooks/useSingleSessionInfoQuery";

type QueryOpts = { enabled?: boolean };

const useMeetingInfoQuery = (
  sessionId: string | undefined,
  opts: QueryOpts = { enabled: true }
) => {
  return useSingleSessionInfoQuery(sessionId, {
    enabled: Boolean(opts?.enabled),
    refetchOnInterval: true,
  });
};

export default useMeetingInfoQuery;
